export type CellContent = string | null;

/** Hex color '#RRGGBB' */
export type HexColor = `#${string}`;

export type TableCell = {
  content: CellContent;
  bold: boolean;
  alignment: 'left' | 'center' | 'right';
  backgroundColor?: HexColor;
};

export type TableRow = {
  cells: TableCell[];
};

export type Table = {
  headerRowCount: number;
  frozenRowCount: number;
  rows: TableRow[];
};

export type Sheet = {
  name: string;
  table: Table;
};

// Helper functions to build spreadsheet models
//
// Benefits of builder functions:
// - return fully typed objects
// - provide default values
// - allow type extension (adding new properties won't break existing code)

export const buildCell = (cell: Partial<TableCell> = {}): TableCell => ({
  ...cell,
  content: cell.content ?? null,
  bold: cell.bold ?? false,
  alignment: cell.alignment ?? 'left',
});

export const buildRow = (cells: TableCell[]): TableRow => ({ cells });

export const buildTable = (table: Partial<Table> = {}): Table => ({
  headerRowCount: table.headerRowCount ?? 0,
  frozenRowCount: table.frozenRowCount ?? 0,
  rows: table.rows ?? [],
});

export const buildSheet = (sheet: Sheet): Sheet => sheet;

export const buildEmptyRow = (length: number): TableRow => ({
  cells: Array.from({ length }, () => buildCell()),
});
